// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"inputwiththumbnail_inputFile__2I7dB"};